:host {
  display: grid;
  container-type: inline-size;
  container-name: host-container;
  block-size: 100%;
  inline-size: 100%;
  align-items: center;
  justify-content: center;
}

.slide {
  display: grid;
  grid-template-columns: 1fr 1fr;
  block-size: 100%;
  max-block-size: 700px;
  max-inline-size: 1100px;
  background-color: var(--color-accent-surface-elevation-1);
  border-radius: var(--dialog-border-radius, 16px);
  overflow: hidden;

  &__illustration {
    overflow: hidden;
    object-fit: cover;
    object-position: left;
    block-size: 100%;
    inline-size: 100%;
  }

  &__main {
    display: grid;
    block-size: 100%;
    inline-size: 100%;
    padding: 48px;
    transform: translateY(4px);
    transition: var(--switch-step-transtion-time) all;
    opacity: 0;

    &--visible {
      transform: translateY(0);
      opacity: 1;
    }
  }

  &__main-container {
    display: grid;
    place-self: center;
    gap: var(--spacing-gap-xxl);
    max-inline-size: 480px;
  }

  &__main-header {
    display: grid;
    gap: var(--spacing-gap-xxl);
  }

  &__main-title {
    display: flex;
    flex-direction: column;
    letter-spacing: 0.02em;
  }

  &__main-description {
    display: grid;
    gap: 40px;
    color: var(--color-text-neutral-disabled);
    max-inline-size: 370px;
  }
}

.teams-list {
  inline-size: 100%;
  max-inline-size: 400px;
  --ch-combo-box__popover-max-inline-size: 400px;
}

.main-btn {
  inline-size: 100%;
  max-inline-size: 124px;
}

@container host-container (max-width: 768px) {
  .slide {
    grid-template-columns: 1fr 2fr;
  }
}

@container host-container (max-width: 640px) {
  .slide {
    grid-template-columns: 1fr 5fr;
  }
}

// WA (this class should be defined on Mercury
.hyperlink {
  text-decoration: underline;
  cursor: pointer;
}
// WA checkboxes labels should not include margin-block-start when
// placed inside a field-inline.
.field-inline > .label-agreement {
  margin-block-start: 0 !important;
}
